import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../firebase/AuthContext";
import { getApiUrl } from "../../config/api";

// The signed-in user's AI usage from GET /me: this week against its quota, this
// 28-day cycle, and `weeks` finished weeks. Loads when the caller mounts;
// reload() asks again. Shared by "My AI usage" and the Assistant's settings panel.
export default function useMyUsage(weeks) {
  const { currentUser } = useAuth();
  const [usage, setUsage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = await currentUser.getIdToken();
      const response = await fetch(
        `${getApiUrl()}/api/v2/usage-billing/me?weeks=${weeks}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      // A proxy error page (a 502 from Cloud Run, say) isn't JSON.
      const data = await response.json().catch(() => ({}));
      if (response.ok && data.success) {
        setUsage(data);
      } else {
        setError(data.error || `Request failed (${response.status})`);
      }
    } catch (err) {
      console.error("Failed to load usage:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [currentUser, weeks]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { usage, error, loading, reload };
}
